import {ContractProvider} from "../../bl/enums/ContractProvider";

export async function findProjectRequests (context, params) {
    try  {
        context.commit('setLoading', true, {root: true})
        let page = params.page;
        delete params.page;
        let res = await axios.post(`/api/v1/forms/findOnRevision?page=${page}`, params);
        return res.data;
    } catch(e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

export async function getProjectFromOpServices (context, params) {
    try {
        context.commit('setLoading', true, {root: true})
        let page = params.page;
        delete params.page;
        let res = await axios.post(`/api/v1/opservices/getProjectsFromOpServices?page=${page}`, params);
        return res.data;
    } catch(e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})

    }
}

export async function getProject(context, { id, fields, filter, order, rel }) {
    try {
        context.commit('setLoading', true, {root: true});

        const { data } = await axios.get(`/api/v1/projects/${id}`, {
            params: {
                fields,
                filter,
                order,
                'with': rel
            }
        });

        // context.commit('setProject', data);

        return data;
    } catch (e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

export async function rejectProject(context, { id, reason_id }) {
    context.commit('setLoading', true, {root: true})
    try {
        const {data} = await axios.post(`/api/project/${id}/reject`, { 'reason_id': reason_id })

        context.commit('partialUpdate', {
            status_named: data.status_named,
            time_remaining: data.time_remaining,
            status: data.status,
            resolution_date: new Date()
        });
    } catch(e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

export async function archiveProject(context, {id, resolution_id, resolution_other}) {
    context.commit('setLoading', true, {root: true})
    try {
        const {data} = await axios.post(`/api/project/${id}/archive`, {
            resolution_id,
            resolution_other
        })

        context.commit('partialUpdate', {
            status: data.status,
            status_named: data.status_named,
            resolution_date: new Date()
        });
    } catch(e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

export async function preApproveProject(context, id) {
    context.commit('setLoading', true, {root: true})
    try {
        const {data} = await axios.post(`/api/project/${id}/preapprove`)

        context.commit('partialUpdate', {
            status: data.status,
            status_named: data.status_named,
            color_flag: data.color_flag,
            time_remaining: data.time_remaining
        });

        return data;
    } catch(e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}


export async function approveProject(context, id) {
    context.commit('setLoading', true, {root: true})
    try {
        const {data} = await axios.post(`/api/project/${id}/approve`)

        context.commit('partialUpdate', {
            status: data.status,
            status_named: data.status_named,
            color_flag: data.color_flag,
            time_remaining: data.time_remaining
        });

        context.commit('setRelationship', {
            propKey: 'finance',
            value: {
                minimal_investment: data.finance.minimal_investment,
                first_payment_date: data.finance.first_payment_date,
                initial_payment_url: data.finance.initial_payment_url
            }
        });

        return data;
    } catch(e) {
        swal("Ups!", e.response.data.error, "error");
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

export async function publishProject(context, {id, first_payment_date}) {
    context.commit('setLoading', true, {root: true})
    try {
        const {data} = await axios.post(`/api/project/${id}/public`, {first_payment_date})

        context.commit('partialUpdate', {
            status: data.status,
            status_named: data.status_named,
            color_flag: data.color_flag,
            time_remaining: data.time_remaining
        });

        return data;
    } catch(e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

export async function generateContracts(context, {pid, ids, signing_type_wish}) {
    context.commit('setLoading', true, {root: true})
    try {
        const {data} = await axios.post(`/api/project/${pid}/generate_contracts`,{
            ids: ids
            , signing_type_wish: signing_type_wish
        }).catch(function (error) {
            if (error.response) {
                console.log(error.response.data.message)
                swal("Ups!", error.response.data.message, "error")
            }
        });

        context.commit('setRelationship', {
            propKey: 'contracts',
            value: data
        });

        return data;
    } catch(e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

export async function sendContracts(context, {pid, id, signing_type, acceptance_caption, date_limit, days, ivr, isPromissory = false}) {
    context.commit('setLoading', true, {root: true})
    try {
        let endpoint = 'send_contracts_email';

        if (signing_type == ContractProvider.FAD) {
            endpoint = 'send_contracts_fad';
            if(isPromissory) {
                endpoint = 'send_promissory_contract_fad';
            }
        } else if (signing_type == ContractProvider.MIFIEL) {
            endpoint = "send_contracts";
            if(isPromissory) {
                endpoint = 'send_promissory_contracts';
            }
        }
        
        const {data} = await axios.post(`/api/project/${pid}/${endpoint}/${id}`, {
            acceptance_caption: acceptance_caption,
            date_limit: date_limit,
            days: days,
            ivr: ivr
        })
        context.commit('partialUpdate', {
            status: data.status,
            status_named: data.status_named,
            color_flag: data.color_flag,
            time_remaining: data.time_remaining
        });
    } catch(e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

export async function resendContracts(context, {pid, id, signing_type}) {
    context.commit('setLoading', true, {root: true})
    try {

        // CONTRATOS AUTÓGRAFOS
        let endpoint = 'send_contracts_email';

        // CONTRATOS CON FAD
        if(signing_type == ContractProvider.FAD) {
            endpoint = "re_send_contracts_fad";
        } else if (signing_type == ContractProvider.MIFIEL) {
            // CONTRATOS CON MIFIEL
            endpoint = "re_send_contracts_mi_fiel";
        }
        const {data} = await axios.post(`/api/project/${pid}/${endpoint}/${id}`)
        context.commit('partialUpdate', {
            status: data.status,
            status_named: data.status_named,
            color_flag: data.color_flag,
            time_remaining: data.time_remaining
        });
    } catch(e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

export async function cancelContracts(context, {pid, gid}){
    context.commit('setLoading', true, {root: true})
    try {
        const {data} = await axios.post(`/api/project/${pid}/cancel_contract_group/${gid}`);
        context.commit('partialUpdate', {
            status: data.status,
            status_named: data.status_named,
            color_flag: data.color_flag,
            time_remaining: data.time_remaining
        });
    } catch(e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

export async function returnProjectToSupplier(context, id) {
    context.commit('setLoading', true, {root: true})
    try {
        const {data} = await axios.post(`/api/v2/projects/${id}/returnProjectToSupplier`, {});
        context.commit('partialUpdate', {
            review_date: data.review_date,
            documentation_complete_date: data.documentation_complete_date,
        });
        return data;
    } catch(e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

export async function projectToLeadStatus(context, id) 
{
    context.commit('setLoading', true, {root: true});
    try {
        const {data} = await axios.post(`/api/project/${id}/projectToLeadStatus`, {});    
        context.commit('partialUpdate', {
            review_date: data.review_date,
            status: data.documentation_complete_date,
        });   
        return data; 
    } catch(e) {
        throw e;
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

/**
 * Envía un correo al OS para recordarle de realizar un flujo.
 * @param {int|string} guaranteeId 
 * @param {int|string} flow 1: Verificación de identidad, 2: Revisión de historial crediticio.
 */
export async function requestGuaranteeReminder(context, params) {
    try {
        context.commit('setLoading', true, {root: true});
        await axios.post(`/api/guarantee/post/${params.guaranteeId}/send-reminder/${params.flow}`);

        const text = params.flow == 1 ? "verifique su identidad" : "autorización para consultar su historial crediticio";

        swal(
            "Notificaremos al obligado solidario.",
            `Enviamos un correo al Obligado Solidario en donde se le solicitará la ${text}. \n Por favor comunícate con el/ella para que no se extrañe de este correo y nos ayude en el proceso de solicitud de crédito.`
        )

    } catch (error) {
        swal("Ups!", error, "error")
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}

/**
 * Envía un correo al solicitante con el link para crear su contraseña de acceso.
 * @param {int|string} applicantId 
 * @param {int|string} loanId
 */
export async function requestApplicantOnboardingReminder(context, params) {
    try {
        context.commit('setLoading', true, {root: true});
        await axios.post(`/api/loan/post/applicant-onboarding/notification`, {
            project_id: params.loanId,
            user_id: params.userId,
            case: params.type
        });
        
        // await axios.post(`/api/applicant-onboarding/post/sent-register-email`, {
        //     applicant_id: params.applicantId,
        //     loan_id: params.loanId
        // });

        swal(
            "Notificaremos al solicitante.",
            `Se envió un correo al solicitante para que establezca su contraseña y pueda iniciar su onboarding como solicitante.`
        )

    } catch (error) {
        swal("Ups!", error, "error")
    } finally {
        context.commit('setLoading', false, {root: true})
    }
}
